const RATE_KEY = "px_test_count";
const RATE_TS_KEY = "px_test_ts";
export const MAX_TESTS = 3;
const RATE_WINDOW_MS = 60 * 60 * 1000; // 1 hour — matches server Redis window

// Local dev only: never gate the tester so it can be tested freely.
const DEV = process.env.NODE_ENV === "development";

export function getTestCount(): number {
  if (typeof window === "undefined" || DEV) return 0;
  const ts = parseInt(localStorage.getItem(RATE_TS_KEY) ?? "0", 10);
  if (Date.now() - ts > RATE_WINDOW_MS) {
    localStorage.removeItem(RATE_KEY);
    localStorage.removeItem(RATE_TS_KEY);
    return 0;
  }
  return parseInt(localStorage.getItem(RATE_KEY) ?? "0", 10);
}

export function bumpTestCount(): number {
  if (DEV) return 0;
  const current = getTestCount();
  const next = current + 1;
  if (current === 0) localStorage.setItem(RATE_TS_KEY, String(Date.now()));
  localStorage.setItem(RATE_KEY, String(next));
  return next;
}

// Persist a hard rate-limit (e.g. server returned 429) so a page reload still
// knows the tester can't run, instead of resetting to a runnable state.
export function markRateLimited(): void {
  if (typeof window === "undefined" || DEV) return;
  localStorage.setItem(RATE_TS_KEY, String(Date.now()));
  localStorage.setItem(RATE_KEY, String(MAX_TESTS));
}
